import { render, staticRenderFns } from "./save_button.vue?vue&type=template&id=af40a606&"
import script from "./save_button.vue?vue&type=script&lang=js&"
export * from "./save_button.vue?vue&type=script&lang=js&"
import style0 from "./save_button.vue?vue&type=style&index=0&id=af40a606&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports